import React from "react";
import {t} from "../../../shared-services/translate";

const DeliveryNotesPDP = (props) => {
  const {product, className = "", style} = props;
  const {delivers_saturday: deliversSaturday} = product;

  return <div className={className} style={style}>
    {!deliversSaturday && <>
      <div
        className={`
          flex
          gap-10
          align-items-center
          border-default
          border-color-light
          border-radius-xl
          padding-15
          font-weight-600
          small
          `}
        style={{borderColor: "#F65B2D"}}
      >
        <img alt="no saturday delivery" src="/resources/farmy/images/icons/quick_delivery_truck.svg"/>
        {t("products.no_delivery_on_saturday")}
      </div>
    </>
    }
  </div>;
};

export default DeliveryNotesPDP;
